import 'react-app-polyfill/stable';

import React, { Component } from 'react';

import 'react-virtualized/styles.css';

import { muiTheme, muiThemeNext } from './helpers/MUIFiles';
import MuiThemeProviderDepricate from 'material-ui/styles/MuiThemeProvider';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { AccentColor } from 'helpers/AccentColorHelper';

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { ApplicationUIProvider } from '@yuhuinc/ui-library';

import TenantApp from './TenantApp';
import LandlordApp from './LandlordApp';

import { TenantAppRoutes } from './app_routes/TenantAppRoutes';
import { LandlordAppRoutes } from './app_routes/LandlordAppRoutes';
import { MaintenanceAppRoutes } from './app_routes/MaintenanceAppRoutes';

import Cypress from 'containers/Cypress';
import { Router, Route, browserHistory } from 'react-router';

import './index.css';

import { Provider } from 'react-redux';

import store from './store';
import { languageSetup } from 'helpers/Localization';
import { authenticationSetup } from 'helpers/Authentication/index';
import {
  onAuthenticationSuccess,
  onAuthenticationError,
} from 'helpers/Authentication/configurationCallbacks';
import authenticateLandlord from 'helpers/Authentication/authenticateLandlord';
import authenticateTenant from 'helpers/Authentication/authenticateTenant';
import authenticateMaintenance from 'helpers/Authentication/authenticateMaintenance';
import ErrorBoundary from 'errors/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const defaultAccentColor = AccentColor();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
    },
  },
});

function AuthenticationProvider({ children }) {
  const [isAuthenticating, setIsAuthenticating] = React.useState(true);

  React.useEffect(() => {
    languageSetup();
    const authentication = authenticationSetup();

    if (typeof authentication === 'object' && authentication != null) {
      authentication.then(
        (response) => {
          setIsAuthenticating(false);

          return onAuthenticationSuccess(response);
        },
        async (error) => {
          setIsAuthenticating(false);

          await onAuthenticationError(error);
        }
      );
    }
  }, []);

  return isAuthenticating ? null : children();
}

export default class Home extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <ApplicationUIProvider>
              <AuthenticationProvider>
                {() => (
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <MuiThemeProvider theme={muiThemeNext(defaultAccentColor)}>
                      <MuiThemeProviderDepricate muiTheme={muiTheme(defaultAccentColor)}>
                        <>
                          <Router history={browserHistory}>
                            <Route path="/" component={TenantApp}>
                              {TenantAppRoutes(authenticateTenant)}
                            </Route>
                            <Route path="companies" component={LandlordApp}>
                              {LandlordAppRoutes(authenticateLandlord)}
                            </Route>
                            <Route path="maintenance" component={LandlordApp}>
                              {MaintenanceAppRoutes(authenticateMaintenance)}
                            </Route>
                          </Router>
                          <Cypress />
                        </>
                      </MuiThemeProviderDepricate>
                    </MuiThemeProvider>
                  </MuiPickersUtilsProvider>
                )}
              </AuthenticationProvider>
            </ApplicationUIProvider>
          </QueryClientProvider>
        </Provider>
      </ErrorBoundary>
    );
  }
}
